// extracted by mini-css-extract-plugin
export default {"mainLogo":"logo_mainLogo__gKZ3C","logoLink":"logo_logoLink__VqfCM"};